import { omit } from 'lodash'
import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  Filter,
  Show,
  SimpleShowLayout,
  useDataProvider,
  usePermissions,
} from 'react-admin'
import { ArchivalToolbar } from '../components/ArchivalToolbar'
import {
  ArchivedSelect,
  AssignmentField,
  AssignmentSelect,
  CourseField,
  CourseIdSelect,
  CourseSelect,
  FullNameField,
  StudentGroupField,
  StudentGroupSelect,
} from '../components/selects'
import { useCourseIds } from '../utils/useCourseIds'

const ListBase = (props) => {
  const course_ids = useCourseIds()
  const { permissions } = usePermissions()
  return (
    <List
      filter={course_ids ? { course_id: course_ids } : null}
      exporter={permissions?.includes('admin') ? undefined : false}
      sort={{ field: 'last_name', order: 'ASC' }}
      filters={<StudentFilter />}
      {...props}
      perPage={25}
    >
      <StudentList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <StudentShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <StudentForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <StudentForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const StudentFilter = (props) => {
  return (
    <Filter style={{ margin: 10 }} {...props}>
      <CourseIdSelect alwaysOn />
      <ArchivedSelect />
    </Filter>
  )
}

const StudentList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField source="first_name" />
    <TextField source="middle_initial" />
    <TextField source="last_name" />
    <CourseField />
  </Datagrid>
)

const StudentShow = (props) => (
  <SimpleShowLayout {...props}>
    <FullNameField />
    <CourseField />
    <StudentGroupField />
    <AssignmentField />
    <TextField label="Rank" source="attributes.rank" />
    <TextField label="Height" source="attributes.height" />
    <TextField label="Width" source="attributes.weight" />
    <TextField label="AFTP Score" source="attributes.aftp" />
    <TextField label="Driver's License" source="attributes.drivers_license" />
    <TextField
      label="Weapons Qualification"
      source="attributes.weapons_qualification"
    />
  </SimpleShowLayout>
)

const StudentForm = (props) => {
  const attrs = omit(props.record.attributes, [
    'first_name',
    'middle_initial',
    'last_name',
    'full_name',
  ])

  const dataProvider = useDataProvider()
  const [assignmentIds, setAssignmentIds] = React.useState([])
  React.useEffect(() => {
    dataProvider
      .getOne('course', { id: props.record.course_id })
      .then(({ data }) => {
        setAssignmentIds(data.assignment_ids)
      })
  }, [dataProvider, props.record.course_id])

  return (
    <SimpleForm toolbar={<ArchivalToolbar />} warnWhenUnsavedChanges {...props}>
      <div fullWidth className="flex-inputs">
        <TextInput source="first_name" />

        <TextInput source="middle_initial" />

        <TextInput source="last_name" />
      </div>
      <CourseSelect disabled />
      <StudentGroupSelect disabled />
      <AssignmentSelect filter={{ id: assignmentIds }} />
      {Object.keys(attrs).map((key) => (
        <TextInput
          fullWidth
          label={`${key[0].toLocaleUpperCase()}${key.slice(1)}`}
          source={`attributes.${key}`}
        />
      ))}
    </SimpleForm>
  )
}
